import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { fetchAccountNotes } from '../../../../redux/reducers/AccountNotes';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Button,
  Box,
  InputAdornment,
  IconButton,
} from '@mui/material';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    position: 'relative',
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
    },
  },
  title: {
    fontFamily: 'articulat-cf", sans-serif !important',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: 24.84,
    textAlign: 'left',
    color: '#3B4149',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  searchInput: {
    marginBottom: 16,
  },
  AddButton: {
    '&&': {
      marginLeft: '10px',
      paddingRight: '15px',
      color: '#FFF',
      background: '#0288D1',
      border: '1px solid #0288D1',
      textTransform: 'none',
      '&:hover': {
        color: '#0288D1',
        backgroundColor: '#FFF',
        borderRadius: '5px',
      },
    },
  },
  container: {
    maxHeight: '400px',
    overflow: 'auto',
  },
}));

const SeeAllNotes = ({ accountId, handleCloseModal }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const notes = useSelector((state) => state.accountNotes.accountNotesData);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    dispatch(
      fetchAccountNotes({
        accountNumber: accountId,
        page: 1,
        orderDirection: '',
        orderBy: '',
        search: '',
        noteType: '',
        statusCode: '',
        creatorId: '',
        noteDate: '',
        notes: '',
        actionPerformed: '',
        changedFields: '',
      }),
    );
  }, [dispatch, accountId]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const filteredNotes = notes.filter
  ((note) => 
    (
      note.notes+" "+
      note.creatorId+" "+
      note.changedFields+" "+
      note.actionPerformed+" "+
      note.statusCode+" "
    ).toLowerCase().includes(searchText)
  );

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h6" component="h2">
        Account Notes
      </Typography>
      <Box display="flex" justifyContent="flex-end">
        <TextField
          label="Search Notes"
          variant="outlined"
          className={classes.searchInput}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton onChange={handleSearchChange} edge="start">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button
          type="submit"
          color="inherit"
          size="medium"
          className={classes.AddButton}
          onClick={(e) => {
            e.stopPropagation();
            handleCloseModal('addNotes');
          }}
        >
          <AddIcon /> Add
        </Button>
      </Box>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: '#4CAF50',
                color: '#FFFFFF',
              }}
            >
              <TableCell>S.NO</TableCell>
              <TableCell>Notes</TableCell>
              <TableCell>Field</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>User</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredNotes
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.accountNoteId}>
                  <TableCell sx={{ width: '5%' }}>{row.seqNo}</TableCell>
                  <TableCell sx={{ width: '70%' }}>{row.notes}</TableCell>
                  <TableCell sx={{ width: '5%' }}>{row.changedFields}</TableCell>
                  <TableCell sx={{ width: '5%' }}>{row.actionPerformed}</TableCell>
                  <TableCell sx={{ width: '5%' }}>{row.statusCode}</TableCell>
                  <TableCell sx={{ width: '10%' }}>{row.creatorId}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={filteredNotes.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default SeeAllNotes;
